export default __webpack_public_path__ + "static/media/talentos.45048283.jpeg";